<template>
  <a-dialog v-model="show" scrollable max-width="35vw" persistent>
    <v-card>
      <v-banner
        class="voting-cnf"
        color="primaryLight1"
        dark
        sticky
        single-line
        tile
      >
        <v-toolbar color="primaryLight1" dark>
          <span>
            {{ title }}
          </span>
          <v-spacer></v-spacer>
          <CloseIcon @click="$emit('input', false)" />
        </v-toolbar>
      </v-banner>
      <v-card-text class="black--text">
        <v-row no-gutters>
          <v-col cols="12" sm="12">
            <span
              v-html="
                $t('agenda.cnfVotingMessage', {
                  status: votingLabel,
                })
              "
            ></span
          ></v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" sm="12">
            <v-text-field
              v-model.trim="txtComment"
              prepend-icon="mdi-comment"
              class="mt-4"
              :label="$t('agenda.lblComment')"
              :rules="rules"
              counter
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-center">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-on="on"
              v-bind="attrs"
              ref="primaryButton"
              color="primaryDark"
              class="font-weight-bold"
              small
              :disabled="!isCommentValid"
              @click="onOkClick"
            >
              <span>{{ $t("btnOk") }}</span>
            </a-btn>
          </template>
          <span>{{ $t("btnOk") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-on="on"
              v-bind="attrs"
              small
              color="secondary"
              class="font-weight-bold ml-2"
              @click="onClose"
              ><span>{{ $t("btnLabelCancel") }}</span>
            </a-btn>
          </template>
          <span>{{ $t("btnLabelCancel") }}</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </a-dialog>
</template>

<script>
import ConfirmDialog from "../ConfirmDialog.vue";
export default {
  components: { ConfirmDialog },
  name: "VotingConfirmationDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    votingLabel: String,
    type: String,
    comment: String
  },
  data() {
    return {
      txtComment: "",
      rules: [(v) => v.length <= 300 || "Max 300 characters"],
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    title() {
      return this.type === "approval"
        ? this.$t("agenda.titleTopiVoting")
        : this.$t("agenda.titleTopiConsent");
    },
    isCommentValid() {
      return String(this.txtComment).length <= 300;
    },
  },
  mounted(){
    this.txtComment = this.comment
  },
  methods: {
    onOkClick,
    onClose,
  },
};

function onOkClick() {
  this.$emit("change", String(this.txtComment).trim());
  this.$emit("input", false);
  this.txtComment = "";
}

function onClose() {
  this.$emit("cancel");
  this.$emit("input", false);
}
</script>

<style scoped>
::v-deep .voting-cnf .v-banner__wrapper {
  padding: 0px !important;
}
</style>